var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKh = function SvgKh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 12c0 2.08.529 4.035 1.46 5.74L12 18.784l10.54-1.044C23.472 16.035 24 14.08 24 12c0-2.078-.529-4.033-1.46-5.738L12 5.218 1.46 6.262A11.946 11.946 0 0 0 0 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M1.459 6.261h21.082A11.997 11.997 0 0 0 12 .001C7.45 0 3.494 2.53 1.459 6.26ZM12 24c4.548 0 8.506-2.53 10.54-6.26H1.46A11.997 11.997 0 0 0 11.999 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M16.174 14.347v-1.565h-1.043v-2.087l-1.043-1.043-1.044 1.043V8.608l-1.043-1.043-1.044 1.043v2.087L9.914 9.652 8.87 10.695v2.087H7.827v1.565H6.783v1.566h10.435v-1.566h-1.044Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgKh;